// src/pages/FAQ.js 
// (Assuming this file contains your FAQ component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar';
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import FAQcontent from './PageComponent/FAQcontent';

function FAQ() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Frequently Asked Questions | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Explore our FAQ for easy answers about our services. Learn more and get the support you need. Visit us now!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/frequently-asked-questions`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Frequently Asked Questions" />
                <meta
                    property="og:description"
                    content="Explore our FAQ for easy answers about our services. Learn more and get the support you need. Visit us now!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/frequently-asked-questions`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <FAQcontent />
                <Footer />
            </div>
        </>
    );
}

export default FAQ;